export const manifest = {
  screens: {
    scr_8ytnkk: { name: "Browse (Shopper)", route: "/", state: {"role":"Shopper","shopperCurrentView":"Browse"}, position: {"x":160,"y":1820} },
    scr_q00f35: { name: "Product detail", route: "/", state: {"role":"Shopper","shopperCurrentView":"Detail"}, position: {"x":1560,"y":1820} },
    scr_anp10f: { name: "Reserve confirm", route: "/", state: {"role":"Shopper","shopperCurrentView":"ReserveConfirm"}, position: {"x":2960,"y":1820} },
    scr_iu0qk1: { name: "Post-pickup", route: "/", state: {"role":"Shopper","shopperCurrentView":"PostPickup"}, position: {"x":4360,"y":1820} },
    scr_2269jj: { name: "Claim result", route: "/", state: {"role":"Shopper","shopperCurrentView":"ClaimResult"}, position: {"x":0,"y":0}, isDefaultRow: true },
    scr_yqlrbe: { name: "Overview (Dispensary)", route: "/", state: {"role":"Dispensary","businessCurrentView":"Overview"}, position: {"x":160,"y":3800} },
    scr_h7bn5n: { name: "Menu management", route: "/", state: {"role":"Dispensary","businessCurrentView":"Menu"}, position: {"x":1560,"y":3800} },
    scr_re2wx3: { name: "Orders / pickups", route: "/", state: {"role":"Dispensary","businessCurrentView":"Orders"}, position: {"x":2960,"y":3800} },
    scr_4pa7nn: { name: "Settings", route: "/", state: {"role":"Dispensary","businessCurrentView":"Settings"}, position: {"x":1400,"y":0}, isDefaultRow: true },
  },
  sections: {
    sec_j2fkqa: { name: "Shopper purchase flow", x: 0, y: 1600, width: 5720, height: 1180 },
    sec_sq7tu3: { name: "Dispensary management", x: 0, y: 3580, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_2269jj" },
    { kind: "screen", id: "scr_4pa7nn" },
    { kind: "section", id: "sec_j2fkqa", children: [
      { kind: "screen", id: "scr_8ytnkk" },
      { kind: "screen", id: "scr_q00f35" },
      { kind: "screen", id: "scr_anp10f" },
      { kind: "screen", id: "scr_iu0qk1" },
    ] },
    { kind: "section", id: "sec_sq7tu3", children: [
      { kind: "screen", id: "scr_yqlrbe" },
      { kind: "screen", id: "scr_h7bn5n" },
      { kind: "screen", id: "scr_re2wx3" },
    ] },
  ],
}
